import { IDatabase } from './interfaces/IDatabase';
import { IndexedDBDatabase } from './indexeddb/IndexedDBDatabase';

let instance: IDatabase | null = null;

export class DatabaseFactory {
  static getDatabase(): IDatabase {
    if (!instance) {
      instance = new IndexedDBDatabase();
    }
    return instance;
  }

  static async resetDatabase(): Promise<void> {
    if (instance) {
      await instance.clearAll();
      await instance.close();
      instance = null;
    }
  }
}
